
// export default {
//   create_user: "https://full-stack-mern-imj5.onrender.com/api/user/create-user",
//   send_otp: "https://full-stack-mern-imj5.onrender.com/api/auth/send-otp",
//   verify_otp: "https://full-stack-mern-imj5.onrender.com/api/auth/verify-email-otp",
//   get_All_User: "https://full-stack-mern-imj5.onrender.com/api/user/all-users",
//   create_Emg_Req: "https://full-stack-mern-imj5.onrender.com/api/emergency/create",



// get_All_Emg_Req:
// "https://full-stack-mern-imj5.onrender.com/api/emergency/getAllEmgReq",

// update_Emg_Order:
// "https://full-stack-mern-imj5.onrender.com/api/emergency/schedule-req",

// get_All_Locations:
// "https://full-stack-mern-imj5.onrender.com/api/location/all",

// get_My_Emg_Req:
// "https://full-stack-mern-imj5.onrender.com/api/emergency/my-requests",


// get_Todays_Task:
// "https://full-stack-mern-imj5.onrender.com/api/driver/today-task",

// arrived_At_Task:"https://full-stack-mern-imj5.onrender.com/api/driver/arrived",
// completed_Task:"https://full-stack-mern-imj5.onrender.com/api/driver/completed",

// // completed_Task: "https://full-stack-mern-imj5.onrender.com/api/driver/completed",


// create_Location:"https://full-stack-mern-imj5.onrender.com/api/location/create",


// assign_Zone:
// "https://full-stack-mern-imj5.onrender.com/api/supervisor/assign-zone",

// get_Supervisor_Locations:
// "https://full-stack-mern-imj5.onrender.com/api/supervisor/getsupervisor-location",

// get_Locations_By_Zone:
// "https://full-stack-mern-imj5.onrender.com/api/location/get-location-by-zone",



// delete_User:
// "https://full-stack-mern-imj5.onrender.com/api/user/delete-user",
// };









const Api = {
  create_user: "https://full-stack-mern-imj5.onrender.com/api/user/create-user",
  send_otp: "https://full-stack-mern-imj5.onrender.com/api/auth/send-otp",
  verify_otp: "https://full-stack-mern-imj5.onrender.com/api/auth/verify-email-otp",
  get_All_User: "https://full-stack-mern-imj5.onrender.com/api/user/all-users",
  create_Emg_Req: "https://full-stack-mern-imj5.onrender.com/api/emergency/create",

  get_All_Emg_Req:
    "https://full-stack-mern-imj5.onrender.com/api/emergency/getAllEmgReq",

  update_Emg_Order:
    "https://full-stack-mern-imj5.onrender.com/api/emergency/schedule-req",

  get_All_Locations:
    "https://full-stack-mern-imj5.onrender.com/api/location/all",

  get_My_Emg_Req:
    "https://full-stack-mern-imj5.onrender.com/api/emergency/my-requests",

  get_Todays_Task:
    "https://full-stack-mern-imj5.onrender.com/api/driver/today-task",

  arrived_At_Task:
    "https://full-stack-mern-imj5.onrender.com/api/driver/arrived",

  completed_Task:
    "https://full-stack-mern-imj5.onrender.com/api/driver/completed",

  create_Location:
    "https://full-stack-mern-imj5.onrender.com/api/location/create",

  assign_Zone:
    "https://full-stack-mern-imj5.onrender.com/api/supervisor/assign-zone",

  get_Supervisor_Locations:
    "https://full-stack-mern-imj5.onrender.com/api/supervisor/getsupervisor-location",

  get_Locations_By_Zone:
    "https://full-stack-mern-imj5.onrender.com/api/location/get-location-by-zone",

  delete_User:
    "https://full-stack-mern-imj5.onrender.com/api/user/delete-user",
};

export default Api;